export const SEND_OUT_SELF_REGISTER_LINKS_FORM_ID = 'send-out-self-register-links-form-id';

export const LINK_TEST_ID = 'generate-link-step-link-test-id';
export const COPY_LINK_BUTTON_TEST_ID = 'generate-link-step-copy-link-button-test-id';

export const SHARE_LINK_BUTTON_TEST_ID = 'share-link-step-share-link-button-test-id';

export const SELF_REGISTER_LINK_PAGE_SPINNER_TEST_ID = 'self-register-link-page-spinner-test-id';
